import React from "react";
import {
  COMMUNICATION_CHANNEL_KINDS,
  MessagingChannelConfig,
} from "@/types/messaging-channel-config";
import { ChannelCard } from "./ChannelCard";

interface ChannelsListProps {
  hotelId: string;
  configs: MessagingChannelConfig[];
}

export const ChannelsList: React.FC<ChannelsListProps> = ({
  hotelId,
  configs,
}) => (
  <div className="flex flex-col gap-4">
    {COMMUNICATION_CHANNEL_KINDS.map((channel) => {
      const row = configs.find((c) => c.channel === channel) ?? null;
      return (
        <ChannelCard
          key={channel}
          hotelId={hotelId}
          channel={channel}
          config={row}
        />
      );
    })}
  </div>
);
